import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { makeSearchPath, proposalPath } from '@/utils'
import { ProposalNode } from '@/apollo/graphql'

interface IProposalRow {
  node: ProposalNode
}

const ProposalRow: React.FC<IProposalRow> = ({ node }) => {
  const navigate = useNavigate()
  const { customerId } = useParams()

  return (
    <tr
      onClick={() =>
        navigate(
          makeSearchPath(proposalPath, {
            customerId,
            id: node.id,
          }),
        )
      }
    >
      <td>{node.id}</td>
      <td>{node.carSubModel?.carModel.name}</td>
      <td>{node.carSubModel?.carModel.brand.name}</td>
    </tr>
  )
}

export default ProposalRow
